module.exports = __webpack_public_path__ + "static/turtle-creek-house20-c17fd39555f830d872e3e2a227006a93.jpg";